<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.shipmentStatus === 'D' || row.shipmentStatus === 'R'
              ? 'warning'
              : row.shipmentStatus === 'N'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_shipmentStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.shipmentCode },
                  query: { shipmentNo: row.shipmentNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { code: row.shipmentCode },
                  query: { shipmentNo: row.shipmentNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_export') || '导出合同'"
            placement="top"
            v-if="allow('E')"
          >
            <i
              class="el-icon-download tool-btn"
              @click="shipmentExport(row)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="'装柜完成'"
            placement="top"
            v-if="allow('C')"
          >
            <i
              class="el-icon-circle-check tool-btn"
              @click="stuffingComplete(row)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="回退"
            placement="top"
            v-if="allow('D')"
          >
            <i class="el-icon-refresh-left tool-btn" @click="rollback(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>

    <back-form
      :visible.sync="backFormDialogVisible"
      :shipmentCode="backFormDialogOption.shipmentCode"
      :shipmentStatus="backFormDialogOption.shipmentStatus"
      :title="backFormDialogOption.title"
      @reload="() => this.$emit('reload')"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import BackForm from '../back-form'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: {BackForm},
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      backFormDialogVisible: false,
      backFormDialogOption: {
        visbile: false,
        shipmentCode: '',
        shipmentStatus: '',
        title: this.$l('form_back_reason') || '回退原因',
      },
    }
  },
  methods: {
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'transport-shipment-detail',
        params: { ...params, pageType },
        query,
      })
    },
    rollback({ shipmentCode, shipmentNo, shipmentStatus }) {
      this.$confirm('确认要回退发运单【' + shipmentNo + '】吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.backFormDialogVisible = true
        this.backFormDialogOption.shipmentCode = shipmentCode
        this.backFormDialogOption.shipmentStatus = shipmentStatus
      })
    },
    shipmentExport({ shipmentCode }) {
      this.loadingOpen()
      this.$api
        .shipmentInfoCheckDataApi({ shipmentCode })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            const taskName = `factory-shipment`
            this.addExportTask(taskName, shipmentCode)
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async addExportTask(taskName, shipmentCode) {
      const context = {
        shipmentCode: shipmentCode,
        type: 'all',
      }
      return await this.$api
        .SYS_EXPORT_TASK(taskName, context)
        .then((res) => {
          const { status } = res || {}
          if (200 === status) {
            this.$message({
              message:
                this.$l('INDEX.added_to_the_download_center') ||
                '导出任务已经添加到下载中心，请稍后从下载中心下载文件',
              type: 'success',
            })
            return
          }
          this.$message.error(
            this.$l('INDEX.Description_Failed_to_add_export_task') ||
              '导出任务添加失败'
          )
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(
            this.$l('INDEX.Description_Failed_to_add_export_task') ||
              '导出任务添加失败'
          )
        })
    },
    stuffingComplete({ shipmentCode, shipmentNo }) {
      this.$confirm(
        `${this.$l('dialog_title_stuffing_complete') ||
          '是否确认该发运单装柜完成？'}【${shipmentNo}】`,
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .shipmentInfoStuffingCompleteApi({ shipmentCode })
          .then((res) => {
            this.loadingClose()
            const { status, msg: message } = res

            if (status === 200) {
              this.$message({
                showClose: true,
                message:
                  this.$l('tips_stuffing_complete_ok') ||
                  '确认装柜，操作成功！',
                type: 'success',
              })
              this.$emit('reload')
              return
            }

            if (status === 203) {
              this.$message({
                dangerouslyUseHTMLString: true,
                message,
                type: 'error',
                duration: 5000,
                showClose: true,
                customClass: 'stuffing-message',
              })
              return
            }
            this.$message.error(
              this.$l('tips_stuffing_complete_no') || '确认装柜，操作失败！'
            )
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
  },
}
</script>
<style lang="scss">
.stuffing-message {
  p.el-message__content {
    > p {
      line-height: 28px;
      strong {
        margin-left: 4px;
      }
    }
  }
}
</style>
